import {
  ISharedFileRequestResponse,
  SharedFileRequestJobType
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";
import { selectorIsSharedFileDriversLicenseContext } from "./selectorIsSharedFileDriversLicenseContext";
import { selectorIsSharedFileBusinessCardContext } from "./selectorIsSharedFileBusinessCardContext";
import { selectorIsSharedFileResumeContext } from "./selectorIsSharedFileResumeContext";
import {
  ICOIExtractionInterface,
  IDriversLicenseExtractionResponse,
  IBusinessCardExtractionResponse,
  IResumeExtractionResponse,
  IAutoInsuranceExtractionResponse
} from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { selectorIsSharedFileCOIContext } from "./selectorIsSharedFileCOIContext";
import { selectorIsSharedFileAutoInsuranceContext } from "./selectorIsSharedFileAutoInsuranceContext";

export function selectorSharedFileExtractedFields(
  sharedFile: ISharedFileRequestResponse | undefined
):
  | ICOIExtractionInterface
  | IDriversLicenseExtractionResponse
  | IBusinessCardExtractionResponse
  | IResumeExtractionResponse
  | IAutoInsuranceExtractionResponse
  | undefined {
  if (!selectorIsSharedFileNotNoneContext(sharedFile?.contextType)) {
    return undefined;
  }

  let extractedFields:
    | ICOIExtractionInterface
    | IDriversLicenseExtractionResponse
    | IBusinessCardExtractionResponse
    | IResumeExtractionResponse
    | IAutoInsuranceExtractionResponse
    | undefined;

  if (selectorIsSharedFileDriversLicenseContext(sharedFile?.contextType)) {
    extractedFields = sharedFile?.jobs
      .filter(job => job.type === SharedFileRequestJobType.Extraction)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IDriversLicenseExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IDriversLicenseExtractionResponse);
  } else if (selectorIsSharedFileBusinessCardContext(sharedFile?.contextType)) {
    extractedFields = sharedFile?.jobs
      .filter(job => job.type === SharedFileRequestJobType.Extraction)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IBusinessCardExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IBusinessCardExtractionResponse);
  } else if (selectorIsSharedFileResumeContext(sharedFile?.contextType)) {
    extractedFields = sharedFile?.jobs
      .filter(job => job.type === SharedFileRequestJobType.Extraction)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IResumeExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IResumeExtractionResponse);
  } else if (selectorIsSharedFileCOIContext(sharedFile?.contextType)) {
    // This is insurance COI
    extractedFields = sharedFile?.jobs
      .filter(job => job.type === SharedFileRequestJobType.Extraction)
      .reduce((acc, job) => {
        const extractedFields = job.extractedFields as ICOIExtractionInterface;

        return { ...acc, ...extractedFields };
      }, {} as ICOIExtractionInterface);
  } else if (
    selectorIsSharedFileAutoInsuranceContext(sharedFile?.contextType)
  ) {
    extractedFields = sharedFile?.jobs
      .filter(job => job.type === SharedFileRequestJobType.Extraction)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IAutoInsuranceExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IAutoInsuranceExtractionResponse);
  }

  return extractedFields && Object.keys(extractedFields).length > 0
    ? extractedFields
    : undefined;
}
